function s() {
  function c(t, n) {
    return n.find((r) => r.type == t) ?? null;
  }
  function u(t, n) {
    return n.find((o) => o.id == t);
  }
  function e(t) {
    if (!t || t == "") return null;
    try {
      const n = t.replaceAll("&quot;", '"'), o = n.indexOf("="), r = n.substring(0, o).trimStart(), l = n.substring(o + 2, n.length - 2);
      return {
        [r]: l
      };
    } catch {
      return null;
    }
  }
  return { getBlock: c, ownBlock: u, blockAttributes: e };
}
export {
  s as u
};
